import React from 'react'
import PropTypes from 'prop-types'

import Text from './Text'

const styles = {
  container: {
    marginBottom: 24,
  },
  title: {
    fontFamily: 'Inter-Bold',
    fontSize: 18,
    fontWeight: 700,
  },
}

export const SecondaryTitle = ({ text }) => (
  <div style={styles.container}>
    <Text style={styles.title}>{text}</Text>
  </div>
)

SecondaryTitle.propTypes = {
  text: PropTypes.string.isRequired,
}
